exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".whitebox[data-v-10869686]{background:#fff;border:1px solid #eaecef;box-sizing:border-box;border-radius:2px;padding-top:10px;cursor:pointer;box-shadow:0 17px 31px rgba(99,102,109,.07)}@media only screen and (min-width:1023px){.whitebox[data-v-10869686]{max-width:149px}}@media only screen and (min-width:768px) and (max-width:992px){.whitebox[data-v-10869686]{max-width:149px}}.whitebox p[data-v-10869686]{color:#090909}.whitebox[data-v-10869686]:hover{box-shadow:none;border-color:#090909}.whitebox:hover p[data-v-10869686]{color:#0f0}.initial_padding[data-v-10869686]{padding-top:125px}li[data-v-10869686]{list-style-type:none}li[data-v-10869686]:before{content:\"\\B7\";position:absolute;left:17px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-10869686","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/services.vue
// module id = 334
// module chunks = 0